export enum TimeModeType {
    date = 'date',
    week = 'week',
    month = 'month',
    year = 'year',
    period = 'period',
    custom = 'custom',
    all = 'all',
}
